import axios from "../../http/axios";
import {
  GET_SEASONALITY_SCHEMAS,
  DELETE_SEASONALITY_SCHEMAS,
  UPDATE_SEASONALITY_SCHEMAS,
  CREATE_SEASONALITY_SCHEMAS,
  token,
} from "./types";

export const getSeasonalitySchemas = () => dispatch => {
  const url = "/user-schemas/UserSeasonality/";
  return axios
    .get(url, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: GET_SEASONALITY_SCHEMAS,
        payload: res.data
      });
    });
};

export const deleteSeasonalitySchemas = id => dispatch => {
  const url = `/user-schemas/UserSeasonality/${id}/`;
  return axios
    .delete(url, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: DELETE_SEASONALITY_SCHEMAS,
        payload: res
      });
    });
};

export const updateSeasonalitySchemas = (data, id) => dispatch => {
  const url = `/user-schemas/UserSeasonality/${id}/`;
  return axios
    .patch(url, data, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: UPDATE_SEASONALITY_SCHEMAS,
        payload: res
      });
    });
};
export const addSeasonalitySchemas = data => dispatch => {
  const url = `/user-schemas/UserSeasonality/`;
  return axios
    .post(url, data, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: CREATE_SEASONALITY_SCHEMAS,
        payload: res
      });
    });
};
// /user-schemas/UserSeasonality/



// WEBPACK FOOTER //
// ./src/store/actions/seasonalitySchemas.js